module.exports = __webpack_public_path__ + "img/contact-geo.b0ba9937.svg";